import { render, staticRenderFns } from "./ContactMessages.vue?vue&type=template&id=dc5c1732&"
import script from "./ContactMessages.vue?vue&type=script&lang=js&"
export * from "./ContactMessages.vue?vue&type=script&lang=js&"
import style0 from "./ContactMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports